import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react';
import scorm_api from '../../hooks/scormAPI';
import { authContext } from "../../context/AuthContext";
import { useHistory, useParams } from 'react-router';
import moment from 'moment';

import Loading from "../helper/Loading"
import CenterButtonWithHeader, { CenterButtonWithHeaderArray } from '../helper/CenterButtonWithHeader';
import { withTranslation } from 'react-i18next';


const { REACT_APP_GIBMP } = process.env;

// using an IFRAME, the LMS requires a user action to open the player, otherwise it loads without sound. I used a button to open it

// does a get request to the backed with username and course ID when mounted, if data is returned loads that in,
// whenever LMS.setValue cms.suspend_data is called it makes the post request to the backend to save the progress
// this may be changed to LMS.commit
const Articulate = props => {
  const mounted = useRef(true)
  const idRef = useRef() // a cache of the courseRecordID so that it can be used in the POST request during unmounting
  const startDateRef = useRef()

  const userMain = useContext(authContext)
  const history = useHistory()

  const token = userMain.accessToken

  const {t} = props

  const headers = {
    headers: {
      'Authorization': token
    }
  }

  const user = userMain.user

  const params = useParams()

  const locState = history.location.state

  const prevStatus = locState.prevStatus
  const trainingId = locState.trainingId
  const fromView = locState.fromView // if the video is being rewatched, this will disable the take quiz button after finishing the video

  console.log("Previous status (may be undefined)",prevStatus)

  const [go, setGo] = useState(false) // to autoStart without button if there is previous suspend data
  const [exited, setExited] = useState(false)
  const [loading, setLoading] = useState(true)
  const [invalidID, setInvalidID] = useState(false) // if the id entered in the URL is invalid
  const [completed, setCompleted] = useState(false)
  // const [courseProgressID, setCourseProgressID] = useState(null) // used to update the courseProgress record

  // when play is clicked, pushes location state with an id (for backend) and a hyperlink to the resource (for the LMS player)
  const [hyperlink, setLink] = useState(locState ? locState.courseSrc : null)

  const quizSrc = locState ? locState.quizSrc : null

  // id can also be grabbed from url (not needed if navigating from main page, but if the user wants to manually type in course link)
  const courseID = params.id

  // console.log("Record id", courseProgressID, "Loading", loading, "go", go)


  // scorm useEffect
  useEffect(() => {
    console.log("Mounted SCORM API, dev")

    scorm_api()

    // window.API_1484_11.apiLogLevel = 2; // Log everything (Info)
    window.API_1484_11.apiLogLevel = 2;


    // mount update hooks 
    window.API_1484_11.on("SetValue.cmi.suspend_data", saveAll);
    window.API_1484_11.on("Terminate", onExit);
    // window.API_1484_11.on("LMSSetValue.cmi.interactions", onQuizSave);


    // when the component is mounted, it grabs the course progress
    grabProgress()


    // add a return function here to clear the window.API_1484_11 and window.simplifyScorm?
    return () => {
      onUnload()
      console.log("UnMounted SCORM")
      window.API_1484_11.reset()

      mounted.current = false

    }


  }, []) // eslint-disable-line react-hooks/exhaustive-deps


  // // attempting to make create when button clicked
  // useEffect(()=>{
  //   if(go===true){

  //   }
  // },[go])

  const onExit = () => {
    onUnload()

    // if the status is complete then it will display the take quiz option. Otherwise it just displays return
    console.log("STATUS", window.API_1484_11.cmi.completion_status, getJSON())
     // eslint-disable-next-line
    if(window.API_1484_11.cmi.completion_status == 'completed') 
      setCompleted(true)
    setExited(true)

  }

  const onUnload = () => {
    console.log("Updating end date and status, the current id is:", idRef.current)

    const data = getJSON()

    // updates with the enddate and calcs total session time based on end - start
    const endDate = moment()
    const status = (prevStatus==='passed') ? 'passed' : data.completion_status
    // if (status === "completed") setCompleted(true) // not using

    axios.post('/api/courseProgress/progress/' + idRef.current, {
      ENDDATE: endDate.format('YYYY-MM-DD HH:mm:ss'),
      TOTALTIMEINMILLISECOND: endDate.diff(startDateRef.current),
      STATUS: status,
      trainingId: trainingId
    }, headers)
  }

  const grabProgress = async () => {

    let tempLink = null
    let tempInvalid = false

    // check if the courseID exists in the system
    if (hyperlink === null) {
      console.log("Getting hyperlink")
      const res = await axios.get('/api/course/' + courseID)

      // if the course exists, then set the hyperlink to the given one
      if (res.data.course) {
        tempLink = res.data.course.hyperlink

        // if it doesn't, then display an error
      } else tempInvalid = true

      if (mounted.current) {
        if (tempInvalid) setInvalidID(tempInvalid)
        setLink(tempLink)
      }

    }

    // grabs the course data
    // if it exists, check the completetion status. is status is incomplete, then grab the suspend data. else do nothing
    // afterwards make a new courseRecord with the suspend data
    const res = await axios.get('/api/courseProgress', {
      params: {
        username: user.username,
        COURSEID: courseID,
        trainingId: trainingId
      }
    })
    const data = res.data
    const course = data.course
    const scorm = data.scorm

    console.log("Data", data)

    // defaults
    let suspendData = ""
    let lessonStatus = "incomplete"
    let totalTime = 0

    // grab the status and data, later it will only set the data if incomplete
    if (course) {
      lessonStatus = course.STATUS
      if (lessonStatus === "incomplete") {
        console.log("Status incomplete, grabbing suspend data and total time")
        suspendData = scorm.find(e => e.SCORMPARAM === "cmi.suspend_data").SCORMVALUE
        totalTime = course.TOTALTIMEINMILLISECOND
      }
    }

    createRecord(lessonStatus, suspendData, totalTime)

  }


  const setWindowData = (progress, status) => {
    window.API_1484_11.cmi.suspend_data = progress
    window.API_1484_11.cmi.completion_status = status
  }

  // update course progress record and scorm values, called when hook triggers (when suspend data is set (after user finishes a slide))
  // not async, goes in the background. May want to make async for error checking
  const saveAll = async () => {
    const currentData = getJSON()
    const id = idRef.current

    console.log("Updating values (the status and time of the courseProgress, and the three scrom values)", id, currentData)

    const endDate = moment()
    console.log(endDate)

    // if the prevStatus is passed, then leave the status as passed.
    const status = (prevStatus==='passed') ? 'passed' : currentData.completion_status

    await axios.post('/api/courseProgress/progress/' + id, {
        ENDDATE: endDate.format('YYYY-MM-DD HH:mm:ss'),
        TOTALTIMEINMILLISECOND: endDate.diff(startDateRef.current),
        STATUS: status,
        trainingId: trainingId
      }, headers)

    await axios.post('/api/courseProgress/scorm', {
        COURSEID: courseID,
        username: user.username,
        SCORMPARAM: "cmi.core.lesson_status",
        SCORMVALUE: status,
      }, headers)

    await axios.post('/api/courseProgress/scorm', {
        COURSEID: courseID,
        username: user.username,
        SCORMPARAM: "cmi.suspend_data",
        SCORMVALUE: currentData.suspend_data,
      }, headers)

    await axios.post('/api/courseProgress/scorm', {
        COURSEID: courseID,
        username: user.username,
        SCORMPARAM: "cmi.core.exit",
        SCORMVALUE: currentData.exit,
      }, headers)

  }

  // creates the new courseProgress and SCORM values, saves the returned record id for future updates
  const createRecord = async (status, suspendData, totalTime) => {

    const dataToSave = {
      username: user.username,
      COURSEID: courseID,
      trainingId: trainingId,
      STATUS: status,//currentData.core.lesson_status,
      pageViewed: null,
      TOTALTIMEINMILLISECOND: 0,//totalTime, // this is how long each session has lasted //moment.duration(currentData.core.session_time).asMilliseconds() + moment.duration(currentData.core.total_time).asMilliseconds(),
      // SYSTEMINFO: ipa,
      scorms: [
        {
          SCORMPARAM: "cmi.core.exit",
          SCORMVALUE: "" //currentData.core.exit
        },
        {
          SCORMPARAM: "cmi.suspend_data",
          SCORMVALUE: suspendData //currentData.suspend_data
        },
        {
          SCORMPARAM: "cmi.core.lesson_status",
          SCORMVALUE: status //currentData.core.lesson_status
        },
      ]

    }
    console.log("Creating this record", dataToSave)

    const res = await axios.post('/api/courseProgress', dataToSave, headers)

    if (mounted.current) {

      // **** FOR TESTING, DELETE THIS IN THE ACTUAL THING (this just enables updating to be triggered without having to open the SCORM)
      console.log("") // added console.log here so if you search for console.log you will find this section
      window.runUpdate = saveAll
      // ********************************

      idRef.current = res.data.courseProgressID
      startDateRef.current = moment()

      setWindowData(suspendData, status)

      // start the iframe automatically if there is loaded data, as the LMS provides a button for proper starting
      if (suspendData !== "") setGo(true)

      setLoading(false)

    }
  }

  const getJSON = () => {
    return window.API_1484_11.cmi.toJSON()
  }

  // needed to go back twice
  const onReturn = () => {
    history.goBack()
    // history.go(-2)
  }

  // an awkward way to ensure that goBack on the quiz returns to the training page with the proper state
  const takeQuiz = () => {
    //const quizSrc = locState.quizSrc
    history.push('/lms/' + courseID + '/quiz', { quizSrc, fromVideo: true, trainingId })
  }


  const src = `${REACT_APP_GIBMP}/BLOB` + hyperlink
  // const quizSrc = 

  return (
    <>
      {invalidID === true ? <h1> {t('Articulate.InvalidCourseId')} </h1> :
        loading ? <Loading /> :
          // takeQuiz?
          // if exited, checks completed and not from view, if true then both buttons, otherwise just return button
          exited ? (completed && !fromView && quizSrc) ? <CenterButtonWithHeaderArray title={t('Articulate.ReturnMainPageProceedtoQuiz')}  buttons={[{ text: t('Articulate.Return') , onClick: onReturn, variant: "outlined" }, { text: t('Articulate.Proceed'), onClick: takeQuiz }]} /> :
            <CenterButtonWithHeader title={t('Articulate.ReturnMainPage')} text={t('Articulate.Return')} onClick={onReturn} /> :
            go ? <iframe title={t('Articulate.TrianingVideo')} src={src} width='1024' height='658'></iframe> :
              <CenterButtonWithHeader title={t('Articulate.StartTraining')}  text={t('Articulate.BeginTraining')} onClick={() => setGo(true)} />

      }
    </>
  )
}


export default withTranslation()(Articulate);